import { Injectable } from '@angular/core';
import { TranslationService } from './translation.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RtlService {
  $isRTL = new BehaviorSubject<boolean>(false);

  constructor(private translationService: TranslationService) {
    this.initializeRTL();
    this.subscribeToLanguageChanges();
  }

  private initializeRTL(): void {
    this.updateDirection(this.translationService.isRTL());
  }

  private subscribeToLanguageChanges(): void {
    this.translationService.currentLanguage$.subscribe((language) => {
      console.log('RtlService: language changed to', language);
      this.updateDirection(language === 'he');
    });
  }

  private updateDirection(isRTL: boolean): void {
    const htmlElement = document.documentElement;
    const bodyElement = document.body;
    if (isRTL) {
      htmlElement.setAttribute('dir', 'rtl');
      htmlElement.setAttribute('lang', 'he');
      bodyElement.classList.add('rtl');
    } else {
      htmlElement.setAttribute('dir', 'ltr');
      htmlElement.setAttribute('lang', 'en');
      bodyElement.classList.remove('rtl');
    }

    this.$isRTL.next(isRTL);
  }
}
